import React, { PropsWithChildren } from 'react'
import { YaTrackerImpression } from '@yanolja-rnd/ya-tracker/index.react'

interface IImpressionProps {
  onImpressed?: () => void
  /* options */
  root?: Element | null
  rootMargin?: string
  threshold?: number | number[]
  disabled?: boolean
}
const Impression = (props: PropsWithChildren<IImpressionProps>) => {
  return <YaTrackerImpression {...props}>{props.children}</YaTrackerImpression>
}

export default Impression
